module.exports = __webpack_public_path__ + "media/images/icon_popup_licence-a045f8a52575d605a0e9f2758a1d3ed9.png";